import { Component, OnInit } from "@angular/core";

@Component({
    selector: "app-generic-contact-details",
    templateUrl: "./erupi-generic-contact-details.component.html",
    styleUrls: ["./erupi-generic-contact-details.component.scss"],
    standalone: false
})
export class ErupiGenericContactDetailsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
